<template>
  <div class="prizeshare-box">
    <div class="join-box">
       <button class="join-btn" @click="handleShow">我要参加</button>
    </div>
    <div class="rule-box">
      <rule-list></rule-list>
    </div>
    <van-popup v-model="show" class="custom-popup" :close-on-click-overlay="false">
      <div class="phone-desc">
        <h3>提示</h3>
        <p class="desc-1">参与活动需升级到最新版本，<br>请点击确定后下载安装</p>
      </div>
      <div class="form-btn-box">
        <button class="form-button form-cancel" @click="handleCancel">取消</button>
        <button class="form-button" @click="handleJoin">确定</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import ruleList from './component/shareRule.vue'

export default {
  components: {
    [Popup.name]: Popup,
    ruleList
  },
  data () {
    return {
      show: false,
      shareData: {
        link: '',
        title: '',
        desc: '',
        imgUrl: ''
      }
    }
  },
  created () {
  },
  methods: {
    handleShow () {
      this.show = true
    },
    handleCancel () {
      this.show = false
    },
    handleJoin () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '海天琴岛通', '我要参加app', '升级页', '', '003'])
      }
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}

</script>
<style lang='scss' scoped>
.custom-popup {
  padding: 15px 20px;
  border-radius: 10px;
  width: 70%;
  height: auto;
  h3 {
    font-size: 18px;
    text-align: center;
    margin-bottom: 10px;
  }
  .phone-desc {
    font-size: 15px;
    line-height: 1.8;
    text-align: center;
  }
  .form-btn-box {
    display: flex;
    justify-content: space-around;
  }
  .form-button {
    box-sizing: border-box;
    width: 45%;
    margin: 30px 10px 15px;
    padding: 8px 5px;
    font-size: 16px;
    color: #fff;
    border-radius: 20px;
    outline: none;
    background-color:#4E73F4;
  }
  .form-cancel {
    background-color:#ddd;
  }
}
.prizeshare-box {
  min-height: 100vh;
  background: #EBF3FF;
}
.join-box {
  height: 100vh;
  position: relative;
  background: url('https://oss.aqdpay.com/appweb/drugPrize/bg.jpg') no-repeat left top;
  background-size: cover;
}
.join-btn {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  padding: 10px 40px;
  color: #fff;
  border-radius: 60px;
  border: 1px solid #fff;
  background: linear-gradient(180deg,#27acda, #3153bf);
  box-shadow: 0px 2px 4px 0px rgba(44,68,104,0.80);
}
.rule-box {
  padding: 18px 15px;
}
</style>
